module.exports = __webpack_public_path__ + "static/media/main.266e2514.jpg";